module.exports = __webpack_public_path__ + "51dbb285cc90c161a76893f83c38573b.webp";